import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import StatusBar from "../../components/StatusBar/StatusBar";

export const STATUS_BAR_STATE_STREAM = "StatusBarStateStream";
export const STATUS_BAR_ACTIONS = "StatusBarActionsStream";

export interface StatusBarAnonymousJavaState {
    readonly anonymous: true;
    readonly balance: number;
    readonly bonusValue: string;
    readonly printVouchersEnabled: boolean;
    readonly shopCurrency: string;
}
export interface StatusBarLoggedInJavaState {
    readonly anonymous: false;
    readonly balance: number;
    readonly bonusValue: string;
    readonly foreignLogin: boolean;
    readonly hasOptInCheckboxChecked: boolean;
    readonly shopCurrency: string;
    readonly userApproved: boolean;
    readonly userLogin: string;
    readonly validForeignUser: boolean;
}

export type StatusBarJavaState =
    | StatusBarAnonymousJavaState
    | StatusBarLoggedInJavaState;

const INITIAL_STATE: StatusBarJavaState = {
    anonymous: true,
    balance: 0,
    bonusValue: "",
    printVouchersEnabled: true,
    shopCurrency: "EUR"
};

const actionsCreators: ActionsCreators<{
    onPrintVoucher: () => void;
    onLogout: () => void;
}> = {
    onLogout: {
        creator: () => "LOGOUT",
        name: STATUS_BAR_ACTIONS
    },
    onPrintVoucher: {
        creator: () => "PRINT_VOUCHER",
        name: STATUS_BAR_ACTIONS
    }
};

export default connectToJava({
    actionsCreators,
    state: {
        [STATUS_BAR_STATE_STREAM]: INITIAL_STATE
    },
    stateMapper: ({
        StatusBarStateStream: { printVouchersEnabled, shopCurrency, ...state }
    }) => ({
        ...state,
        currency: shopCurrency,
        vouchersEnabled: printVouchersEnabled
    })
})(StatusBar);
